"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCardConfig = void 0;
var defaultCardConfig = {
    dark: false,
    padding: {
        desktop: '80px 40px',
        tablet: '60px 40px',
        mobile: '40px 20px'
    },
    margin: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    },
    titleConfig: {
        size: 3
    },
    subtitleConfig: {
        size: 4
    },
    descriptionConfig: {
        align: 'center'
    },
    hrConfig: {}
};
exports.defaultCardConfig = defaultCardConfig;
//# sourceMappingURL=Card.js.map